/**
 * Logout Page
 *
 * Immediately triggers Auth0 logout regardless of authentication state.
 * Accessible at /logout — useful as a hard reset when the app is in a broken state.
 */

import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";

export function LogoutPage() {
  const { logout, isLoading } = useAuth0();

  useEffect(() => {
    if (!isLoading) {
      logout({ logoutParams: { returnTo: window.location.origin } });
    }
  }, [logout, isLoading]);

  return (
    <div className="flex min-h-screen items-center justify-center">
      <p className="text-muted-foreground">Logging out…</p>
    </div>
  );
}
